export const messages = {
  en: {
    homePage: {
      welcome: 'Welcome',
      login: 'Login',
      register: 'Register',
      latestNews: 'Latest News',
      viewAll: 'View All',
      noProducts: 'No products available',
      systemName: 'System Name'
    }
  },
  zh: {
    homePage: {
      welcome: '欢迎',
      login: '登录',
      register: '注册',
      latestNews: '最新资讯',
      viewAll: '查看全部',
      noProducts: '暂无商品',
      systemName: '系统名称'
    }
  }
}